import HeaderComponent from "../subComponent/HeaderComponent";
import React from "react";
import { Container, Typography, Link, Box } from "@mui/material";
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles({
    root: {
        '@media (max-width: 600px)': {
            '& .MuiTypography-h4': {
                fontSize: '1.5em', // Change h4 to h5 equivalent
            },
            '& .MuiTypography-h5': {
                fontSize: '1.25em', // Change h5 to h6 equivalent
            },
            '& .MuiTypography-h6': {
                fontSize: '1em', // Change h6 to p equivalent
                fontWeight: 'bold', // Make it bold
            },
            '& .MuiTypography-body1': {
                fontSize: '0.75em', // Change body1 to p with 0.75px
            },
            '& li': {
                fontSize: '0.9em',
            },
        },
    },
});

const PrivacyPolicy = () => {
    const classes = useStyles();

    return (
        <Box>
            <HeaderComponent />
            <Container>
                <Box p={3} className={classes.root}>
                    <Typography variant="h4" gutterBottom>
                        Privacy Policy
                    </Typography>

                    <Typography variant="body1" gutterBottom>
                        Our Privacy Policy was last updated on
                        <strong> 10th October 2024</strong>
                    </Typography>

                    <Typography variant="body1">
                        This Privacy Policy describes Our policies and procedures on the collection, use and disclosure of Your information when You use the Service and tells You about Your privacy rights and how the law protects You.
                    </Typography>
                    <Box p={0.5} />

                    <Typography variant="body1">
                        We use Your Personal data to provide and improve the Service. By using the Service, You agree to the collection and use of information in accordance with this Privacy Policy.
                    </Typography>
                    <Box p={1} />

                    <Typography variant="h5" gutterBottom>
                        Interpretation and Definitions
                    </Typography>

                    <Typography variant="h6" gutterBottom>
                        Interpretation
                    </Typography>

                    <Typography variant="body1">
                        The words of which the initial letter is capitalized have meanings defined under the following conditions. The following definitions shall have the same meaning regardless of whether they appear in singular or in plural.
                    </Typography>
                    <Box p={1} />

                    <Typography variant="h6" gutterBottom>
                        Definitions
                    </Typography>

                    <Typography variant="body1" >
                        For the purposes of these Privacy Policy:
                    </Typography>

                    <ul>
                        <li>
                            <Typography variant="body1">
                                <strong>"Company"</strong> (referred to as either "the Company", "We", "Us" or "Our" in this Agreement) refers to <strong>INV TECHNOLOGIES</strong>.
                            </Typography>
                        </li>
                        <li>
                            <Typography variant="body1">
                                <strong>"Country"</strong> refers to <strong>INDIA</strong>.
                            </Typography>
                        </li>
                        <li>
                            <Typography variant="body1">
                                <strong>"Device"</strong> means any device that can access the Service such as a computer, a cell phone or a digital tablet.
                            </Typography>
                        </li>
                        <li>
                            <Typography variant="body1">
                                <strong>"Service"</strong> refers to the use of our payment gateway for purchasing products and service.
                            </Typography>
                        </li>
                        <li>
                            <Typography variant="body1">
                                <strong>"Personal Data"</strong>  is any information that relates to an identified or identifiable individual.
                            </Typography>
                        </li>
                        <li>
                            <Typography variant="body1">
                                <strong>"Usage Data"</strong> refers to the data collected automatically, either generated by the use of the Service or from the Service infrastructure itself (for example, the duration of a page visit).
                            </Typography>
                        </li>
                        <li>
                            <Typography variant="body1">
                                <strong>"You"</strong> means the individual accessing or using the Service, or the company, or other legal entity on behalf of which such individual is accessing or using the Service, as applicable.
                            </Typography>
                        </li>
                    </ul>

                    <Typography variant="h5" gutterBottom>
                        Collecting and Using Your Personal Data
                    </Typography>
                    <Typography variant="h6" gutterBottom>
                        Types of Data Collected
                    </Typography>
                    <Typography variant="h6" gutterBottom>
                        Personal Data
                    </Typography>
                    <Typography variant="body1" >
                        While using Our Service, We may ask You to provide Us with certain personally identifiable information that can be used to contact or identify You. Personally identifiable information may include, but is not limited to:
                    </Typography>
                    <ul>
                        <li>
                            <Typography variant="body1">First name and last name
                            </Typography>
                        </li>
                        <li>
                            <Typography variant="body1">Phone number
                            </Typography>
                        </li>
                        <li>
                            <Typography variant="body1">email address
                            </Typography>
                        </li>
                        <li>
                            <Typography variant="body1">billing details
                            </Typography>
                        </li>
                        <li>
                            <Typography variant="body1">payment information
                            </Typography>
                        </li>
                    </ul>
                    <Typography variant="h6" gutterBottom>
                        Usage Data
                    </Typography>
                    <Typography variant="body1" >
                        Usage Data is collected automatically when using the Service.
                    </Typography>
                    <Box p={0.5} />
                    <Typography variant="body1" >
                        Usage Data may include information such as Your Device's Internet Protocol address (e.g. IP address), browser type, browser version, the pages of our Service that You visit, the time and date of Your visit, the time spent on those pages, unique device identifiers and other diagnostic data.                    </Typography>
                    <Box p={0.5} />
                    <Typography variant="body1" >
                        When You access the Service by or through a mobile device, We may collect certain information automatically, including, but not limited to, the type of mobile device You use, Your mobile device unique ID, the IP address of Your mobile device, Your mobile operating system, the type of mobile Internet browser You use, unique device identifiers and other diagnostic data.                    </Typography>
                    <Box p={0.5} />
                    <Typography variant="body1" >
                        We may also collect information that Your browser sends whenever You visit our Service or when You access the Service by or through a mobile device.                    </Typography>
                    <Box p={1} />
                    <Typography variant="h6" gutterBottom>
                        Information Collected while Using the Application</Typography>

                    <Typography variant="body1" >
                        While using Our Application, in order to provide features of Our Application, We may collect, with Your prior permission:</Typography>
                    <ul>
                        <li>
                            <Typography variant="body1">
                                Information regarding your location
                            </Typography>
                        </li>
                    </ul>
                    <Typography variant="body1" >
                        We use this information to provide features of Our Service, to improve and customize Our Service. The information may be uploaded to the Company's servers and/or a Service Provider's server or it may be simply stored on Your device.
                    </Typography>
                    <Box p={0.5} />
                    <Typography variant="body1" >
                        You can enable or disable access to this information at any time, through Your Device settings.
                    </Typography>
                    <Box p={1} />
                    <Typography variant="h5" gutterBottom>
                        Use of Your Personal Data                    </Typography>

                    <Typography variant="body1" >
                        We use the personal data we collect to:
                    </Typography>
                    <ul>
                        <li>
                            <Typography variant="body1">
                                Process your payments and complete transactions.
                            </Typography>
                        </li>
                        <li>
                            <Typography variant="body1">
                                Provide and maintain our services.
                            </Typography>
                        </li>
                        <li>
                            <Typography variant="body1">
                                Send you relevant updates, such as confirmations and service-related messages.
                            </Typography>
                        </li>
                        <li>
                            <Typography variant="body1">
                                Prevent fraudulent activities and secure your account.
                            </Typography>
                        </li>
                        <li>
                            <Typography variant="body1">
                                Improve our services based on user behavior and preferences
                            </Typography>
                        </li>
                    </ul>
                    <Box p={1} />

                    <Typography variant="h5" gutterBottom>
                        Sharing Your Personal Data
                    </Typography>

                    <Typography variant="body1" >We may share your data with:
                    </Typography>
                    <ul>
                        <li>
                            <Typography variant="body1">
                                <strong>Payment Processors:</strong> To process your payments securely.
                            </Typography>
                        </li>
                        <li>
                            <Typography variant="body1">
                                <strong>Service Providers:</strong> Companies that help us run our operations, such as customer support or technical assistance..
                            </Typography>
                        </li>
                        <li>
                            <Typography variant="body1">
                                <strong>Legal Requirements:</strong> When required to comply with legal obligations, enforce terms, or respond to governmental requests.
                            </Typography>
                        </li>
                    </ul>


                    <Box p={0.5} />

                    <Typography variant="h5" gutterBottom>
                        Retention of Your Personal Data
                    </Typography>

                    <Typography variant="body1" >
                    </Typography>The Company will retain Your Personal Data only for as long as is necessary for the purposes set out in this Privacy Policy. We will retain and use Your Personal Data to the extent necessary to comply with our legal obligations (for example, if we are required to retain your data to comply with applicable laws), resolve disputes, and enforce our legal agreements and policies.
                    <Box p={0.5} />
                    <Typography variant="body1" >The Company will also retain Usage Data for internal analysis purposes. Usage Data is generally retained for a shorter period of time, except when this data is used to strengthen the security or to improve the functionality of Our Service, or We are legally obligated to retain this data for longer time periods.
                    </Typography>
                    <Box p={1} />

                    <Typography variant="h5" gutterBottom>
                        Transfer of Your Personal Data
                    </Typography>

                    <Typography variant="body1" >Your information, including Personal Data, is processed at the Company's operating offices and in any other places where the parties involved in the processing are located. It means that this information may be transferred to — and maintained on — computers located outside of Your state, province, country or other governmental jurisdiction where the data protection laws may differ from those of Your jurisdiction.
                    </Typography>
                    <Box p={0.5} />
                    <Typography variant="body1" >
                        Your consent to this Privacy Policy followed by Your submission of such information represents Your agreement to that transfer.
                    </Typography>
                    <Box p={0.5} />
                    <Typography variant="body1" >The Company will take all steps reasonably necessary to ensure that Your data is treated securely and in accordance with this Privacy Policy and no transfer of Your Personal Data will take place to an organization or a country unless there are adequate controls in place including the security of Your data and other personal information.
                    </Typography>
                    <Box p={1} />

                    <Typography variant="h5" gutterBottom>
                        Disclosure of Your Personal Data
                    </Typography>
                    <Typography variant="h6" gutterBottom>
                        Business Transactions
                    </Typography>
                    <Typography variant="body1" >
                        If the Company is involved in a merger, acquisition or asset sale, Your Personal Data may be transferred. We will provide notice before Your Personal Data is transferred and becomes subject to a different Privacy Policy.
                    </Typography>

                    <Box p={1} />
                    <Typography variant="h6" gutterBottom>
                        Law enforcement
                    </Typography>

                    <Typography variant="body1" >
                        Under certain circumstances, the Company may be required to disclose Your Personal Data if required to do so by law or in response to valid requests by public authorities (e.g. a court or a government agency).
                    </Typography>
                    <Box p={1} />

                    <Typography variant="h5" gutterBottom>
                        Other legal requirements
                    </Typography>
                    <Typography variant="body1" >
                        The Company may disclose Your Personal Data in the good faith belief that such action is necessary to:
                    </Typography>

                    <ul>
                        <li>
                            <Typography variant="body1">Comply with a legal obligation.
                            </Typography>
                        </li>
                        <li>
                            <Typography variant="body1">Protect and defend the rights or property of the Company.
                            </Typography>
                        </li>
                        <li>
                            <Typography variant="body1">Prevent or investigate possible wrongdoing in connection with the Service.
                            </Typography>
                        </li>
                        <li>
                            <Typography variant="body1">Protect the personal safety of Users of the Service or the public.
                            </Typography>
                        </li>
                        <li>
                            <Typography variant="body1">Protect against legal liability.
                            </Typography>
                        </li>
                    </ul>

                    <Box p={0.5} />
                    <Typography variant="h5" gutterBottom>
                        Security of Your Personal Data
                    </Typography>
                    <Typography variant="body1" >
                        The security of Your Personal Data is important to Us, but remember that no method of transmission over the Internet, or method of electronic storage is 100% secure. While We strive to use commercially acceptable means to protect Your Personal Data, We cannot guarantee its absolute security.
                    </Typography>
                    <Box p={1} />

                    <Typography variant="h5" gutterBottom>
                        Detailed Information on the Processing of Your Personal Data
                    </Typography>

                    <Typography variant="body1" >
                        We use third-party services to process payments, monitor activity, and provide related services. These third parties may have access to your personal data as required to perform these tasks but are obligated not to disclose or use it for any other purpose.
                    </Typography>
                    <Box p={1} />

                    <Typography variant="h5" gutterBottom>
                        Children's Privacy
                    </Typography>

                    <Typography variant="body1" >
                        Our services are not directed to anyone under the age of 18. We do not knowingly collect personal data from children under 18. If you are a parent or guardian and believe your child has provided us with personal data, please contact us.
                    </Typography>

                    <Box p={1} />

                    <Typography variant="h5" gutterBottom>
                    Links to Other Websites
                    </Typography>

                    <Typography variant="body1" >
                    Our Service may contain links to other websites that are not operated by Us. If you click on a third party link, You will be directed to that third party's site. We strongly advise You to review the Privacy Policy of every site You visit.
                    </Typography>
                    <Box p={0.5} />
                    <Typography variant="body1" >
                    We have no control over and assume no responsibility for the content, privacy policies or practices of any third party sites or services.
                    </Typography>
                    <Box p={1} />

                    <Typography variant="h5" gutterBottom>
                    Changes to this Privacy Policy
                    </Typography>

                    <Typography variant="body1" >
                    We may update Our Privacy Policy from time to time. We will notify You of any changes by posting the new Privacy Policy on this page.
                    </Typography>
                    <Box p={0.5} />
                    <Typography variant="body1" >
                    We will let you know via email and/or a prominent notice on Our Service, prior to the change becoming effective and update the "Last updated" date at the top of this Privacy Policy.
                    </Typography>
                    <Box p={0.5} />
                    <Typography variant="body1" >
                    You are advised to review this Privacy Policy periodically for any changes. Changes to this Privacy Policy are effective when they are posted on this page.
                    </Typography>
                    <Box p={1} />

                    <Typography variant="h5" gutterBottom>
                        Contact Us
                    </Typography>

                    <Typography variant="body1">
                        If you have any questions about this Privacy Policy, You can contact us:
                    </Typography>
                    <ul>
                        <li>
                            <Typography variant="body1">
                                By sending us an email to{" "}
                                <Link href="mailto:payments.invtechnologies@gmail.com">
                                    payments.invtechnologies@gmail.com
                                </Link>.
                            </Typography>
                        </li>
                    </ul>
                </Box>
            </Container>

        </Box>
    )
}
export default PrivacyPolicy;